var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNominative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_modifica_nominativo",
    "data-name": "icona modifica nominativo",
    transform: "translate(-368 -734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_112",
    "data-name": "Tracciato 112",
    d: "M12.921,46.594a.35.35,0,0,0-.349.35v3.111a1.05,1.05,0,0,1-1.046,1.051H1.743A1.05,1.05,0,0,1,.7,50.056V40.924a1.05,1.05,0,0,1,1.046-1.051h3.1a.35.35,0,0,0,0-.7h-3.1A1.75,1.75,0,0,0,0,40.924v9.132a1.75,1.75,0,0,0,1.743,1.752h9.783a1.75,1.75,0,0,0,1.743-1.752V46.945a.35.35,0,0,0-.349-.35Zm0,0",
    transform: "translate(368 696.191)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_113",
    "data-name": "Tracciato 113",
    d: "M117.55.723a1.563,1.563,0,0,0-2.219,0l-6.22,6.252a.351.351,0,0,0-.089.154L108.2,10.1a.352.352,0,0,0,.089.341.348.348,0,0,0,.34.09l2.953-.822a.348.348,0,0,0,.153-.09l6.22-6.252a1.584,1.584,0,0,0,0-2.23ZM109.87,7.2l5.091-5.117,1.642,1.65-5.091,5.117Zm-.328.661,1.312,1.319-1.814.505Zm7.924-5-.37.372-1.642-1.65.37-.372a.868.868,0,0,1,1.233,0l.409.411A.88.88,0,0,1,117.466,2.868Zm0,0",
    transform: "translate(263.582 733.739)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNominative);
export default __webpack_public_path__ + "static/media/edit_nominative.bf0a8a172288a090d8e4d70ebf118375.svg";
export { ForwardRef as ReactComponent };